export default {
  IT_GET_AUDIT_LOGS: {
    url: '/api/v1/audit-logger',
    method: 'get',
  },
};
